import React from "react";
import "./GrammerDetais.css";
import { Player } from "video-react";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardImage } from "mdb-react-ui-kit";

let Grammerdetais = ({ gram }) => {
  // let [chartData , setChartData ] = useState();

  return (
    <div className="text">
      <MDBCard className="mb-3">
        <Player src={gram.video} />
        <MDBCardBody>
          <MDBCardTitle>{gram.name}</MDBCardTitle>
          <MDBCardText>{gram.text}</MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </div>
  );
};

export default Grammerdetais;
